<template>
    <rkm-overlay>
        <rkm-layout-body title="Atendimento domiciliar">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    :id="id"
                    :edit="false"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import Form from "@/components/atencao-basica/atendimento-domiciliar/Form";
import { repository, error, object, data } from '@/mixins'
import { mapActions } from 'vuex';

export default {
    components: { Form },
    created() {
        this.setShowExitFormConfirmation()
    },
    methods: {
        ...mapActions([
            'setShowExitFormConfirmation',
            'unsetShowExitFormConfirmation',
            'setLoading',
            'unsetLoading'
        ]),
        handleExit() {
            this.$router.push({ name: 'atencao-basica-atendimento-domiciliar' })
        },
        handleSave() {
            this.unsetShowExitFormConfirmation()
            this.handleExit()
        },
    },
    mixins: [repository, error, object, data],
    props: {
        id: { type: Number, default: null }
    }
}
</script>